import type { ChecklistState } from "./state";

export const initialState: ChecklistState = {
  "authentication": {
    "items": {
      "auth_strong-passwords": {
        "checked": false,
        "priority": "critical"
      },
      "auth_password-manager": {
        "checked": false,
        "priority": "critical"
      },
      "auth_no-password-reuse": {
        "checked": false,
        "priority": "essential"
      },
      "auth_no-password-sharing": {
        "checked": false,
        "priority": "essential"
      },
      "auth_use-mfa": {
        "checked": false,
        "priority": "critical"
      },
      "auth_device-passkey": {
        "checked": false,
        "priority": "essential"
      },
      "auth_securely-store-backup-codes": {
        "checked": false,
        "priority": "essential"
      },
      "auth_breach-alerts": {
        "checked": false,
        "priority": "recommended"
      },
      "auth_shield-passwords--": {
        "checked": false,
        "priority": "recommended"
      },
      "auth_update-passwords-periodically--": {
        "checked": false,
        "priority": "recommended"
      },
      "auth_never-store-passwords-in-browsers--": {
        "checked": false,
        "priority": "recommended"
      },
      "web_use-incognito": {
        "checked": false,
        "priority": "recommended"
      },
      "auth_make-up-security-questions--": {
        "checked": false,
        "priority": "recommended"
      },
      "auth_use-a-strong-pin--": {
        "checked": false,
        "priority": "recommended"
      },
      "auth_avoid-sms-for-mfa--": {
        "checked": false,
        "priority": "recommended"
      },
      "auth_unique-user-names": {
        "checked": false,
        "priority": "advanced"
      }
    }
  },
  "web_browsers": {
    "items": {
      "web_doubleCheckURLs": {
        "checked": false,
        "priority": "essential"
      },
      "web_update-borwser": {
        "checked": false,
        "priority": "essential"
      },
      "web_ensure-HTTPS": {
        "checked": false,
        "priority": "essential"
      },
      "web_remove-addons": {
        "checked": false,
        "priority": "essential"
      },
      "web_use-incognito": {
        "checked": false,
        "priority": "recommended"
      },
      "web_use-secure-browsers": {
        "checked": false,
        "priority": "recommended"
      },
      "web_separate-browsers-for-separate-tasks": {
        "checked": false,
        "priority": "recommended"
      },
      "web_no_click_here_links": {
        "checked": false,
        "priority": "recommended"
      },
      "web_clear-cookies": {
        "checked": false,
        "priority": "recommended"
      },
      "web_block-trackers": {
        "checked": false,
        "priority": "recommended"
      },
      "web_browser-malware": {
        "checked": false,
        "priority": "recommended"
      },
      "avoid-signing-in-to-browsers": {
        "checked": false,
        "priority": "recommended"
      },
      "web_beware-redirects": {
        "checked": false,
        "priority": "advanced"
      },
      "web_disable-automatic-downloads": {
        "checked": false,
        "priority": "advanced"
      },
      "web_disallow-access-to-sensors": {
        "checked": false,
        "priority": "advanced"
      },
      "web_block-location-tracking": {
        "checked": false,
        "priority": "advanced"
      },
      "web_block-camera-and-microphone": {
        "checked": false,
        "priority": "advanced"
      },
      "web_block-saving-passwords": {
        "checked": false,
        "priority": "advanced"
      },
      "web_block-autofill": {
        "checked": false,
        "priority": "advanced"
      }
    }
  },
  "email": {
    "items": {
      "email_multiple-email-addresses": {
        "checked": false,
        "priority": "essential"
      },
      "auth_strong-passwords": {
        "checked": false,
        "priority": "essential"
      },
      "email_google-checkup": {
        "checked": false,
        "priority": "essential"
      },
      "human_aspect_verify-recipients": {
        "checked": false,
        "priority": "essential"
      },
      "email_no-remote-content": {
        "checked": false,
        "priority": "recommended"
      },
      "email_no-3rd-party-apps": {
        "checked": false,
        "priority": "recommended"
      },
      "email_no-sensitive-data": {
        "checked": false,
        "priority": "recommended"
      },
      "email_anonymous-forwarding": {
        "checked": false,
        "priority": "advanced"
      },
      "email_use-subaddressing": {
        "checked": false,
        "priority": "advanced"
      }
    }
  },
  "messaging": {
    "items": {
      "messaging_end-to-end-encryption": {
        "checked": false,
        "priority": "essential"
      },
      "messaging_only-open-source": {
        "checked": false,
        "priority": "essential"
      },
      "messaging_verify-platform": {
        "checked": false,
        "priority": "essential"
      },
      "messaging_secure-group-chats": {
        "checked": false,
        "priority": "essential"
      },
      "messaging_communication-plans": {
        "checked": false,
        "priority": "recommended"
      },
      "messaging_verify-participants": {
        "checked": false,
        "priority": "recommended"
      },
      "auth_avoid-sms-for-mfa--": {
        "checked": false,
        "priority": "recommended"
      },
      "messaging_use-decentralized-platforms": {
        "checked": false,
        "priority": "advanced"
      }
    }
  },
  "social_media": {
    "items": {
      "social_media_secure-your-account": {
        "checked": false,
        "priority": "essential"
      },
      "social_media_privacy-settings": {
        "checked": false,
        "priority": "essential"
      },
      "social_media_all-interactions-are-public": {
        "checked": false,
        "priority": "essential"
      },
      "social_media_avoid-revealing-too-much": {
        "checked": false,
        "priority": "essential"
      },
      "social_media_attention-what-you-upload": {
        "checked": false,
        "priority": "essential"
      },
      "social_media_avoid-sharing-email-and-phone": {
        "checked": false,
        "priority": "essential"
      },
      "social_media_avoid-over-permissioning": {
        "checked": false,
        "priority": "essential"
      },
      "social_media_3rd-party-integrations": {
        "checked": false,
        "priority": "recommended"
      },
      "social_media_avoid-publishing-geo-data": {
        "checked": false,
        "priority": "recommended"
      },
      "social_media_alis-personas": {
        "checked": false,
        "priority": "advanced"
      },
      "social_media_avoid-social-media": {
        "checked": false,
        "priority": "advanced"
      }
    }
  },
  "home_network_config": {
    "items": {
      "home_network_config_change-default-passwords": {
        "checked": false,
        "priority": "essential"
      },
      "home_network_config_strong-wifi-encryption": {
        "checked": false,
        "priority": "essential"
      },
      "home_network_config_update-router-firmware": {
        "checked": false,
        "priority": "essential"
      },
      "home_network_config_use-vpn": {
        "checked": false,
        "priority": "recommended"
      },
      "home_network_config_network-wide-vpn": {
        "checked": false,
        "priority": "recommended"
      },
      "home_network_config_whitelist-mac-addresses": {
        "checked": false,
        "priority": "recommended"
      },
      "home_network_config_change-ssid-name": {
        "checked": false,
        "priority": "recommended"
      },
      "home_network_config_guest-network": {
        "checked": false,
        "priority": "advanced"
      },
      "home_network_config_close-unused-ports": {
        "checked": false,
        "priority": "advanced"
      },
      "home_network_config_disable-cloud-based-management": {
        "checked": false,
        "priority": "advanced"
      }
    }
  },
  "mobile_devices": {
    "items": {
      "mobile_devices_use-strong-passcodes": {
        "checked": false,
        "priority": "essential"
      },
      "mobile_devices_disable-unused-connecitivty-features": {
        "checked": false,
        "priority": "essential"
      },
      "mobile_devices_keep-os-up-to-date": {
        "checked": false,
        "priority": "essential"
      },
      "mobile_devices_only-apps-from-official-sources": {
        "checked": false,
        "priority": "essential"
      },
      "mobile_devices_limit-use-of-biometrics": {
        "checked": false,
        "priority": "recommended"
      },
      "mobile_devices_reduce-app-count": {
        "checked": false,
        "priority": "recommended"
      },
      "mobile_devices_review-app-permissions": {
        "checked": false,
        "priority": "recommended"
      },
      "mobile_devices_use-offline-maps": {
        "checked": false,
        "priority": "recommended"
      },
      "mobile_devices_limit-personal-adds": {
        "checked": false,
        "priority": "recommended"
      },
      "mobile_devices_regularly-perform-restarts": {
        "checked": false,
        "priority": "recommended"
      },
      "mobile_devices_avoid-public-chargining-stations": {
        "checked": false,
        "priority": "recommended"
      }
    }
  },
  "pc": {
    "items": {
      "pc_keep-system-up-to-date": {
        "checked": false,
        "priority": "essential"
      },
      "pc_backup-data": {
        "checked": false,
        "priority": "essential"
      },
      "pc_beware-of-usb-devices": {
        "checked": false,
        "priority": "essential"
      },
      "pc_lock-your-screen": {
        "checked": false,
        "priority": "essential"
      },
      "pc_disable-voice-assistants": {
        "checked": false,
        "priority": "recommended"
      },
      "pc_limit-installed-apps": {
        "checked": false,
        "priority": "recommended"
      },
      "pc_limit-app-permissions": {
        "checked": false,
        "priority": "recommended"
      },
      "pc_power-off-computer": {
        "checked": false,
        "priority": "recommended"
      },
      "pc_artificial-intel": {
        "checked": false,
        "priority": "recommended"
      },
      "pc_lock-webcam": {
        "checked": false,
        "priority": "recommended"
      },
      "pc_secure-device-physically": {
        "checked": false,
        "priority": "recommended"
      },
      "pc_use-a-firewall": {
        "checked": false,
        "priority": "recommended"
      },
      "pc_use-anti-virius-software": {
        "checked": false,
        "priority": "recommended"
      }
    }
  },
  "personal_finance": {
    "items": {
      "personal_finance_fraud-alerts": {
        "checked": false,
        "priority": "essential"
      },
      "personal_finance_use-credit-freezes": {
        "checked": false,
        "priority": "essential"
      },
      "personal_finance_transaction-notifications": {
        "checked": false,
        "priority": "recommended"
      },
      "personal_finance_use-virtual-cards": {
        "checked": false,
        "priority": "recommended"
      },
      "personal_finance_use-cash": {
        "checked": false,
        "priority": "recommended"
      },
      "personal_finance_online-shopping-persona": {
        "checked": false,
        "priority": "advanced"
      }
    }
  },
  "human_aspect": {
    "items": {
      "human_aspect_social-engineering": {
        "checked": false,
        "priority": "critical"
      },
      "human_aspect_verify-recipients": {
        "checked": false,
        "priority": "critical"
      },
      "human_aspect_beware-popup-notifications": {
        "checked": false,
        "priority": "essential"
      },
      "human_aspect_never-leave-device-unattended": {
        "checked": false,
        "priority": "essential"
      },
      "human_aspect_secure-personal-data": {
        "checked": false,
        "priority": "essential"
      },
      "human_aspect_use-virtual-credit-cards": {
        "checked": false,
        "priority": "recommended"
      },
      "mobile_devices_limit-use-of-biometrics": {
        "checked": false,
        "priority": "recommended"
      },
      "human_aspect_review-app-permissions": {
        "checked": false,
        "priority": "recommended"
      },
      "human_aspect_opt-out-of-public-lists": {
        "checked": false,
        "priority": "recommended"
      },
      "human_aspect_review-privacy-social-media": {
        "checked": false,
        "priority": "recommended"
      },
      "pc_artificial-intel": {
        "checked": false,
        "priority": "recommended"
      },
      "human_aspect_compartmentalize-digitally": {
        "checked": false,
        "priority": "advanced"
      }
    }
  },
  "overview": {
    "items": {}
  },
  "top_five": {
    "items": {
      "auth_strong-passwords": {
        "checked": false,
        "priority": "critical"
      },
      "auth_password-manager": {
        "checked": false,
        "priority": "critical"
      },
      "auth_use-mfa": {
        "checked": false,
        "priority": "critical"
      },
      "human_aspect_social-engineering": {
        "checked": false,
        "priority": "critical"
      },
      "human_aspect_verify-recipients": {
        "checked": false,
        "priority": "critical"
      }
    }
  }
};
